/* eslint-disable operator-linebreak, indent */
import React from 'react';
import ReactDOM from 'react-dom';

import StateMessage from '../../react/OpeningHours/ProductPageState';
import OpeningHours from '../../react/OpeningHours/ProductPageOpeningHours';
import { DeliveryType } from '../../../storeavailability';
import AddToBasketButtonWithAjaxCall
  from '../../react/AddToBasket/AddToBasketButtonWithAjaxCall.jsx';
import { psaVariants, PSA_SWITCHED_OFF }
  from '../../react/PopupStyleAttach/components/PSAPopup/PSAPopup';

const uiLocale = require('../../../utils/UILocale.js');
const uiSettings = require('../../../utils/UISettings.js');
const Analytics = require('../../../analytics');
const deliveryTypeaheadState = require('../../../delivery-typeahead-state');

/**
 * Component CollectInStoreItem
 *
 * Gets appended to the collect in store tab
 */
export default function CollectInStoreItem(storeAvailability, index, availableStoresLength, fupid) {

  // colour the span based on status to help user
  const stockLabelClass = storeAvailability.isOutOfStock() ? 'outOfStock' : 'available';
  let additionalClass = '';
  if (index === 0 && ['CURRYS', 'PCWORLD'].indexOf(storeAvailability.getTradeMark()) > -1) {
    additionalClass = 'first-store';

    if (storeAvailability.isInStock()) {
      additionalClass += ' in-stock';
    }
  } else if ((availableStoresLength - 1) === index) {
    additionalClass = 'last-store';
  }

  const staticStoreStatus = getStaticStoreStatusMessage(storeAvailability);

  let storeDetailsPickupHTMl = '';
  if (storeAvailability.isPickUp()) {
    storeDetailsPickupHTMl
      = `<span class="pickup-description">
          ${uiLocale.getString('component.deliveryslotpicker.pickup.description')}
        </span>`;
  }

  const template = `
    <li class="store ${additionalClass}" id="${storeAvailability.getStoreId()}"
      data-component="collect-in-store-item" data-collapsed="true">
      <div class="content-wrapper">
        <div class="desc">
          <div class="name">${storeAvailability.getStoreName()}</div>
          <div class="distance">${storeAvailability.getStoreDistance()}</div>
          <div class="store-state">
            <a class="store-state-message">${staticStoreStatus === undefined
              ? '<span data-component="product-page-store-state"></span>'
              : staticStoreStatus}
            </a>
            <a class="store-expand"><span>${
              uiLocale.getString('component.deliveryslotpicker.storeinfo')
            }</span></a>
          </div>
          <div class="store-details">
            <div class="store-address">
              ${storeAvailability.getStoreAddress()}
            </div>
            <div data-component="product-page-opening-hours"></div>
            ${storeDetailsPickupHTMl}
          </div>
        </div>
        <div class="availability-button-wrapper">
           <div class="availability ${stockLabelClass}">
             ${storeAvailability.getStockAvailabilityLabel()}
           </div>
           <div class="button-wrapper ${stockLabelClass}">
           </div>
        </div>
      </div>
    </li>
  `;

  const element = document.createElement('UL');
  element.innerHTML = template;
  const collectInStoreItem = element.children[0];

  const openingHours = storeAvailability.getStoreOpeningHours();
  const country = storeAvailability.getCountry();
  const currentDate = new Date();

  const storeStateEl =
    collectInStoreItem.querySelector('[data-component="product-page-store-state"]');
  if (storeStateEl) {
    ReactDOM.render(React.createElement(StateMessage, { openingHours, currentDate }), storeStateEl);
  }

  const openingHoursEl =
    collectInStoreItem.querySelector('[data-component="product-page-opening-hours"]');
  if (openingHoursEl) {
    ReactDOM.render(
      React.createElement(OpeningHours, { openingHours, country, currentDate }), openingHoursEl
    );
  }

  if (!storeAvailability.isOutOfStock()) {
    let psaVariant = PSA_SWITCHED_OFF;
    const psaForMcdEnabled = uiSettings.get('component.psa.mcd');
    if (psaForMcdEnabled) {
      psaVariant = psaVariants[uiSettings.get('component.psa.variant')];
    }

    const buttonWrapperEl =
      collectInStoreItem.querySelector('.button-wrapper');

    ReactDOM.render(
      <AddToBasketButtonWithAjaxCall
        buttonPlacementID={'mcd'}
        psaVariant={psaVariant}
        fupid={fupid}
        quantity={1}
        storeId={storeAvailability.getStoreId()}
        deliveryType={storeAvailability.getAvailabilityType()}
        buttonLabel={storeAvailability.getCollectionLabel()}
        full={false}
        beforeAddingToBasket={() => {
          sendAnalyticsAfterChoosingDeliveryToStore(storeAvailability);
        }}
      />,
      buttonWrapperEl
    );
  }

  return collectInStoreItem;
}


function getStaticStoreStatusMessage(storeAvailability) {
  const deliveryType = storeAvailability.getAvailabilityType();
  const isPickUp = storeAvailability.isPickUp();
  if (deliveryType === DeliveryType.PAY_AND_COLLECT && isPickUp) {
    return uiLocale.getString('component.deliveryslotpicker.pickup.label');
  } if (deliveryType === DeliveryType.PAY_AND_COLLECT) {
    return uiLocale.getString('component.mcd.store_opening_hours.opening_hours');
  } if (storeAvailability.isOutOfStock()) {
    return '';
  } if (!uiSettings.get('component.mcd.store_opening_hours.availability_status')) {
    return uiLocale.getString('component.mcd.store_opening_hours.opening_hours');
  }
  return undefined;
}

function sendAnalyticsAfterChoosingDeliveryToStore(storeAvailability) {
  // dispatch digitalData event
  if (window.appState) {
    window.appState.dispatch({
      type: 'STORE_LOCATOR_STORE_SELECTED',
      payload: {
        storeId: storeAvailability.getStoreId(),
        storeName: storeAvailability.getStoreName()
      }
    });
  }
  Analytics.track('FULFILLMENT_METHOD', 'Collect in Store');
  Analytics.track('DELIVERY_TIMESLOT', storeAvailability.getCollectionLabel());
  Analytics.track('POSTCODE_SEARCH_TYPE',
    deliveryTypeaheadState.selectedSuggestion.inputMethodIsGeoCode);
  Analytics.track('POSTCODE_SEARCH_VALUE',
    deliveryTypeaheadState.selectedSuggestion.valueDisplayed);
  Analytics.track('POSTCODE_SEARCH_VALUE_TYPE',
    deliveryTypeaheadState.selectedSuggestion.inputTypeIsPostCode);
}
